import React, { useState, useEffect } from 'react';
import ReactDOM, {render} from 'react-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

//import './App.css';

/*
import {
//  BikeUI,		
//  Budget,
//  TotalUsers,
//  HowToUse,
//  Segment,
//  TotalProfit,
//  LatestSales,
//  UsersByDevice,
//  LatestProducts,
//  LatestOrders
} from './Tab';
*/

import _ from 'lodash';
import axios from 'axios';
import auth from '../../utils/auth';

import Map from './Map';
import Main from './Main';


const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%'
  },
  tab: {
    backgroundColor: 'white',
    boxShadow: '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
    borderRadius: '4px 4px 0 0' 
  }, 
  tabPanel: {
  	padding: '16px',
    backgroundColor: 'white',
    boxShadow: '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)',
    borderRadius: '0 0 4px 4px'
  }
}));


const PelotonTab = () => {
  const classes = useStyles();

  const extraInfo = auth.getExtraInfo() ? auth.getExtraInfo() : {pretest : 'none'};

  const [tabSelect, setTabSelect] = React.useState(0);

  
  useEffect(() => {	
	}, []);

  const handleTab = (event, newTab) => {
    setTabSelect(newTab);
  };   

  function TabContent(props) {
    const tabSelect = props.tabSelect;
    
    if(tabSelect == 0) { 
      return (  
        <Main />
      );
    } else if(tabSelect == 1) {
      return (  
        <Map />
      );
    } else {
      return (  
        <Box>준비중입니다.</Box>
      );
    }
  }

  function TabList(props) {
    return (
      <Tabs
        value={tabSelect}
        onChange={handleTab}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"          
      >
        <Tab key={0} label={"첫화면"} />	
        <Tab key={1} label={"지도보기"} />	
        <Tab key={2} label={"순위보기"} />	
      </Tabs>
    );
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default" className={classes.tab}>
        <TabList />       
      </AppBar>
 			<Box className={classes.tabPanel}> 
        <TabContent tabSelect={tabSelect} /> 
			</Box>
		</div>
  );
}


export default PelotonTab;
